<template>
   <div>
        <div class="kit__utils__heading">
            <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
        </div>
        <div class="card">
            <div class="card-header card-header-flex">
                <search v-bind="sentDataSearch"></search>
            </div>
            <div class="card-body">
              <tableStatement v-bind="sentTableStatement"/>
            </div>
        </div>
    </div>
</template>

<script>
import search from '@/components/system/table/search/stement'
import tableStatement from '../tableStatement'
export default {
  components: {
    search,
    tableStatement,
  },
  data() {
    return {
      pageType: 'withdraw',
      withdrawType: 'default',
    }
  },
  computed: {
    sentDataSearch: function() {
      return {
        pageType: this.withdrawType,
      }
    },
    sentTableStatement: function() {
      return {
        pageType: this.pageType,
        withdrawType: this.withdrawType,
      }
    },
  },
  methods: {
    checkTypeWithdraw(type) {
      let withdrawType = ''
      switch (type) {
        case 'default':
          withdrawType = 'บัญชีถอนเงิน'
          break
        case 'refund':
          withdrawType = 'บัญชีถอนเงินคืนลูกค้า'
          break
        case 'commission':
          withdrawType = 'บัญชีถอนเงินคอมมิชชั่น'
          break
        default:
          break
      }

      return withdrawType
    },
  },
}
</script>

<style>

</style>
